import {
  AuthContext,
  GenericError,
  MenuContext,
} from '@monash/portal-frontend-common';
import {
  Icon,
  Sidebar,
  SidebarContainer,
  SidebarItem,
  SidebarSection,
} from '@monash/portal-react';
import { useContext, useState } from 'react';
import ACCESS_ROLES from '../../constants/user-roles';
import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react';
import { isAuthorized } from '../utilities/is-authorized';

const Admin = ({ children }) => {
  const { menu, handleMenu, closeMenu, menuRef, size } =
    useContext(MenuContext);
  const authCtx = useContext(AuthContext);
  const userRoles = authCtx?.user?.roles;

  const hasNotificationsAccess = [
    ACCESS_ROLES.NOTIFICATIONS_CRITICAL,
    ACCESS_ROLES.NOTIFICATIONS_NON_CRITICAL,
  ].some((x) => userRoles?.includes(x));

  // Nav AX
  const paths = [
    '/',
    '/users',
    '/notifications',
    '/theme-builder',
    '/api-docs',
    '/feedback-manager',
  ];
  const [selectedPageIndex, setSelectedPageIndex] = useState(
    paths.indexOf(window.location.pathname)
  );

  return (
    <SidebarContainer onLeft={true}>
      <Sidebar
        title="Admin"
        ifMenu={menu}
        toggleMenu={handleMenu}
        closeMenu={closeMenu}
        size={size}
        menuRef={menuRef}
        selected={selectedPageIndex}
        onChange={setSelectedPageIndex}
      >
        <SidebarSection title="App features">
          <SidebarItem
            linkTo="/"
            text="Apps"
            icon={<Icon.Home />}
            onMenu={closeMenu}
          />
        </SidebarSection>

        <SidebarSection title="Global features">
          {isAuthorized(userRoles, [
            ACCESS_ROLES.IMPERSONATION,
            ACCESS_ROLES.MOCK_IMPERSONATION,
          ]) && (
            <SidebarItem
              linkTo="/users"
              text="Users"
              icon={<Icon.User />}
              onMenu={closeMenu}
            />
          )}

          {hasNotificationsAccess && (
            <SidebarItem
              linkTo="/notifications"
              text="Notifications"
              icon={<Icon.Alert />}
              onMenu={closeMenu}
            />
          )}

          {isAuthorized(userRoles, [ACCESS_ROLES.SUPPORT_DEVELOPER]) && (
            <SidebarItem
              linkTo="/theme-builder"
              text="Theme builder"
              icon={<Icon.Adjustments />}
              onMenu={closeMenu}
            />
          )}

          {['dev', 'localhost'].some((x) =>
            window.location.host.includes(x)
          ) && (
            <SidebarItem
              linkTo="/api-docs"
              text="API Docs"
              icon={<Icon.Book />}
              onMenu={closeMenu}
            />
          )}

          {isAuthorized(userRoles, [ACCESS_ROLES.SUPPORT_DEVELOPER]) && (
            <SidebarItem
              linkTo="/analytics"
              text="Analytics"
              icon={<Icon.ChartBar />}
              onMenu={closeMenu}
            />
          )}

          {isAuthorized(userRoles, [
            ACCESS_ROLES.SUPPORT_DEVELOPER,
            ACCESS_ROLES.ADMIN,
          ]) && (
            <SidebarItem
              linkTo="/feedback-manager"
              text="Feedback Manager"
              icon={<Icon.Activity />}
              onMenu={closeMenu}
            />
          )}
        </SidebarSection>
      </Sidebar>
      <SentryErrorBoundary fallback={<GenericError />}>
        {children}
      </SentryErrorBoundary>
    </SidebarContainer>
  );
};

export default Admin;
